angular.module("AccountingBoxApp").directive("errSrc", function() {
  return {
    // restrict: 'E',
    link: function(scope, element, attrs) {
      /* scope.$watch(function() {
          return attrs.src;
        }, function (value) {
          if (!value) {
            element.attr('src', attrs.errSrc);
          }
      });*/

      element.bind("error", function() {
        element.attr("src", attrs.errSrc);
        element.attr("reload", 'yes')
      });
    }
  };
});

angular
  .module("AccountingBoxApp")
  .directive("attachmentId", function(LoopBackAuth, $rootScope) {
    return {
      // restrict: 'E',
      link: function(scope, element, attrs) {
        if (attrs.zoomable !== undefined) {
          window.mediumZoom(element.get(0), {
            margin: 50,
            container: {
              width: window.innerWidth * 1.25,
              height: window.innerHeight * 1.25,
              top: 0,
              bottom: 0,
              right: 0,
              left: 0
            }
          });
        }
        scope.$on("$destroy", function() {
          element.attr("src", "");
        });

        scope.$watch(
          function() {
            let reload = "";
            let format = attrs.format || "medium";
            let height = attrs.height || 800;
            // const shouldReload = attrs.reload || attrs.src === "assets/images/file.png"
            const shouldReload = false
            if (shouldReload) {
              reload = "&reloadImage=" + new Date().getTime();
              element.attr(
                "src",
                $rootScope.getAttachmentPreview(attrs.attachmentId, format, height) + reload
              );
            }
            return attrs.attachmentId;
          },
          function(attachmentId) {

            if (attachmentId) {
              let format = attrs.format || "medium";
              let height = attrs.height || 800;
              element.attr(
                "src",
                $rootScope.getAttachmentPreview(attachmentId, format, height)
              );
            }
          }
        );
      }
    };
  });

angular
  .module("AccountingBoxApp")

  // Angular File Upload module does not include this directive
  // Only for example

  /**
   * The ng-thumb directive
   * @author: nerv
   * @version: 0.1.2, 2014-01-09
   */
  .directive("ngThumb", [
    "$window",
    function($window) {
      var helper = {
        support: !!($window.FileReader && $window.CanvasRenderingContext2D),
        isFile: function(item) {
          console.log("item: ", item);
          return angular.isObject(item) && item instanceof $window.File;
        },
        isImage: function(file) {
          console.log("file: ", file);
          var type =
            "|" + file.type.slice(file.type.lastIndexOf("/") + 1) + "|";
          return "|jpg|png|jpeg|bmp|gif|".indexOf(type) !== -1;
        }
      };

      return {
        restrict: "A",
        template: '<canvas class="preview"/>',
        link: function(scope, element, attributes) {
          console.log("link ng-thymb");
          if (!helper.support) return;

          var params = scope.$eval(attributes.ngThumb);

          if (!helper.isFile(params.file)) return;
          if (!helper.isImage(params.file)) return;

          var canvas = element.find("canvas");
          var reader = new FileReader();

          reader.onload = onLoadFile;
          reader.readAsDataURL(params.file);

          function onLoadFile(event) {
            console.log("onload file: ", event);
            var img = new Image();
            img.onload = onLoadImage;
            img.src = event.target.result;
          }

          function onLoadImage() {
            console.log("onload image: ");
            var width =
              params.width || (this.width / this.height) * params.height;
            var height =
              params.height || (this.height / this.width) * params.width;
            canvas.attr({ width: width, height: height });
            canvas[0].getContext("2d").drawImage(this, 0, 0, width, height);
          }
        }
      };
    }
  ]);
